// Global namespace of the lib (window.wi). Extend it, never replace it: a site may create it first.
window.wi = window.wi || {};
